import {
  CHATAI_LOADING_STATUS,
  ChatAIInput,
  useChatContext,
} from '@ltvco/refresh-lib/v2';
import { CarRepairOutlined } from '@mui/icons-material';
import { useState, useCallback, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

import { theme } from 'theme';

import { FeatureHeader } from '../components/FeatureHeader';
import { FeaturePageShell } from '../components/FeaturePageShell';

import { MessagesContainer } from './RepairCostEstimatorContent/MessagesContainer';

export const RepairCostEstimatorPage = () => {
  const {
    messages,
    loadingStatus,
    sendMessage,
    handleNewChat,
    handleFeatureNameChange,
  } = useChatContext();
  const [shouldResetInputs, setShouldResetInputs] = useState<boolean>(false);
  const location = useLocation();
  const prevLocationKeyRef = useRef<string | undefined>(location.key);

  const handleNewEstimate = useCallback((): void => {
    handleNewChat();
    setShouldResetInputs(true);
  }, [handleNewChat]);

  const handleResetComplete = useCallback((): void => {
    setShouldResetInputs(false);
  }, []);

  useEffect(() => {
    handleFeatureNameChange('createRepairCostEstimatorBot');
  }, [handleFeatureNameChange]);

  useEffect(() => {
    if (
      prevLocationKeyRef.current &&
      prevLocationKeyRef.current !== location.key
    ) {
      handleNewChat();
      setShouldResetInputs(true);
    }
    prevLocationKeyRef.current = location.key;
  }, [location.key, handleNewChat]);

  return (
    <FeaturePageShell
      header={
        <FeatureHeader
          icon={
            <CarRepairOutlined sx={{ color: theme.palette.primary.main }} />
          }
          title="Repair Cost Estimator"
        />
      }
      chatInput={
        <ChatAIInput
          isLoading={
            loadingStatus.message !== CHATAI_LOADING_STATUS.IDLE.message
          }
          disabled={messages.length === 0}
        />
      }
    >
      <MessagesContainer
        messages={messages}
        loadingStatus={loadingStatus}
        onSendMessage={sendMessage}
        onNewEstimate={handleNewEstimate}
        shouldResetInputs={shouldResetInputs}
        onResetComplete={handleResetComplete}
      />
    </FeaturePageShell>
  );
};
